import React from "react";
import {translatePartnerText} from '../../locales/language';

import TransportMobile320 from "./images/mobile/320.webp";
import TransportMobile384 from "./images/mobile/384.webp";
import TransportMobile544 from "./images/mobile/544.webp";
import TransportMobile2240 from "./images/mobile/2240.webp";
import TransportDesktop544 from "./images/desktop/544.webp";
import TransportDesktop736 from "./images/desktop/736.webp";
import TransportDesktop944 from "./images/desktop/944.webp";
import TransportDesktop1681 from "./images/desktop/1681.webp";

const mobileSrcSet = `${TransportMobile320} 320w, ${TransportMobile384} 384w, ${TransportMobile544} 544w, ${TransportMobile2240} 2240w`;
const desktopSrcSet = `${TransportDesktop544} 544w, ${TransportDesktop736} 736w, ${TransportDesktop944} 944w, ${TransportDesktop1681} 1681w`;

type CallToActionImageProps = {
    className: string;
    loading?: "eager" | "lazy";
    sizes: string;
};

function CallToActionImage({className, loading = "lazy", sizes}: CallToActionImageProps) {
    return (
        <picture>
            <source
                media="(min-width: 576px)"
                srcSet={desktopSrcSet}
                sizes={sizes}
                width={1681}
                height={4096}
            />
            <img
                src={TransportMobile544}
                srcSet={mobileSrcSet}
                sizes={sizes}
                width={2240}
                height={5458}
                alt={translatePartnerText('Finding a shipping option')}
                className={className}
                loading={loading}
                decoding="async"
                draggable="false"
            />
        </picture>
    );
}

export default CallToActionImage;
